import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ScrollLockContextType {
  isScrollLocked: boolean;
  lockScroll: () => void;
  unlockScroll: () => void;
}

const ScrollLockContext = createContext<ScrollLockContextType | undefined>(undefined);

export const useScrollLockContext = () => {
  const context = useContext(ScrollLockContext);
  if (!context) {
    throw new Error('useScrollLockContext must be used within a ScrollLockProvider');
  }
  return context;
};

interface ScrollLockProviderProps {
  children: ReactNode;
}

export const ScrollLockProvider: React.FC<ScrollLockProviderProps> = ({ children }) => {
  const [isScrollLocked, setIsScrollLocked] = useState(false);

  const lockScroll = () => setIsScrollLocked(true);
  const unlockScroll = () => setIsScrollLocked(false);

  return (
    <ScrollLockContext.Provider value={{ isScrollLocked, lockScroll, unlockScroll }}>
      {children}
    </ScrollLockContext.Provider>
  );
};
